import script from "./PendingRegistrations.vue?vue&type=script&setup=true&lang=js"
export * from "./PendingRegistrations.vue?vue&type=script&setup=true&lang=js"

import "./PendingRegistrations.vue?vue&type=style&index=0&id=1eb3e56f&lang=css"

const __exports__ = script;

export default __exports__